import Navbar from "../../components/main/Navbar";
import SearchHeader from "../../components/main/SearchHeader";
import loading from "../../photos/Spinner-1.9s-137px.gif";
import Table2 from "../../components/main/Table/Table2";
import {HeaderStorHouse} from "../../data/TablesHeader";
import ListsOperations from "../../tools/consts";
import Pagination from "../../components/main/Pagination";
import DeleteModal from "../../components/atoms/DeleteModal";
import {Toaster} from "react-hot-toast";
import React from "react";
import TableSearchHeader from "../../components/CustomTable/TableSearchHeader";
import {useServiceContext} from "../services/ServiceContext";
import {useStorehouseContext} from "./StorehouseContext";
import Loading from "../../components/atoms/Loading";
import AddDeviceModal from "./components/AddDeviceModal";
import ChangeDevicePasswordModal from "./components/ChangeDevicePasswordModal";
import ChangeDeviceStatusModal from "./components/ChangeDeviceStatusModal";

const StorehouseScreen = () => {
    const {
        listState,
        modalState,
        onSearchBtnClick,
        deleteStorehouseDevice,
        changePage,
        closeModal,
        openModal,
    } = useStorehouseContext();

    return (<div className="pb-7.5px">
        <Navbar titles={["انبار محـصول‌ها"]}/>
        <div
            className="mr-7.5px ml-7.5px mt-5 bg-white shadow-md rounded-sm pr-7.5px pl-7.5px pt-7.5px pb-7.5px  "
            dir="rtl">
            <TableSearchHeader
                title={"فهرست دستگاه‌های انبار"}
                number={listState.countAll}
                placeholder={"جست و جو: شماره سریال، نام سازنده"}
                onSearchBtnClick={onSearchBtnClick}
                countUnit={"دستگاه"}
                buttnText={"افزودن دستگاه جدید"}
                hasBtn={true}
                exportFile={false}
                onClick={() => {
                    openModal("add", null)
                }}
            />

            {listState.loading ? (<Loading height={"h-66"}/>)
                : (<>
                    <Table2
                        headers={HeaderStorHouse}
                        pageNumber={listState.pageNumber}
                        tableData={listState.list}
                        heightEmptyState={"h-66"}
                        emptyText={"دستگاه ثبت شده‌ای یافت نشد."}
                        hasOperation={true}
                        limit={listState.pageLimit}
                        operations={
                            ListsOperations.getStorehouseList
                            (
                                (item) => openModal("delete", item),
                                (item) => openModal("status", item),
                                localStorage.getItem('token'),
                                (item) => openModal("edit", item)
                            )}
                    />

                    <Pagination
                        changePage={changePage}
                        countAll={listState.countAll}
                        currentPage={listState.pageNumber}
                    />
                    <AddDeviceModal/>

                    <ChangeDevicePasswordModal/>
                    <ChangeDeviceStatusModal/>

                    <DeleteModal
                        text={`آیا برای حذف “${modalState.selectedItem == null ? "" : modalState.selectedItem.serialNumber}” مطمئن هستید؟`}
                        showDeleteModal={modalState.isOpen && modalState.mode === "delete"}
                        closeDeleteModal={closeModal}
                        RemoveItem={deleteStorehouseDevice}
                        title={"اخطار حذف دستگاه"}
                    />

                </>)}
            <Toaster/>
        </div>

    </div>);

}
export default StorehouseScreen